import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const useSetSearchCriteriaEffect = ({ setSearchCriteria }) => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location?.state?.searchCriteria && setSearchCriteria) {
      setSearchCriteria(location.state.searchCriteria);

      history.replace({
        pathname: location.pathname,
        state: undefined
      });
    }
  }, [location, setSearchCriteria, history]);
};

export default useSetSearchCriteriaEffect;
